import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  IconButton,
} from '@mui/material'
import { Button, Box } from '@material-ui/core'

import { LinkedFrontTicketsTable } from './components/LinkedFrontTicketsTable'
import { useEffect, useState } from 'react'
import { FrontTicketSearchTable } from './components/FrontTicketSearchTable'
import { getFrontTickets } from '../Apis/routes/front'
import CloseIcon from '@mui/icons-material/Close'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'

const VIEW_LINKED = 'linked'
const VIEW_SEARCH = 'search'
export const DRAFT_TICKET_TYPE = 'draft-ticket'

export const FrontModal = ({ open, handleClose, ticket }) => {
  const [activeView, setActiveView] = useState(VIEW_LINKED)
  const [frontTickets, setFrontTickets] = useState([])
  useEffect(() => {
    getFrontTickets(ticket.id).then((res) => {
      setFrontTickets(res)
    })
  }, [activeView])

  const displayTitle = () => {
    if (activeView === VIEW_LINKED) {
      return 'CONVERSATIONS FRONT LIÉES'
    } else {
      return 'LIER UNE CONVERSATION FRONT'
    }
  }

  return (
    <Dialog fullWidth maxWidth="lg" open={open} onClose={handleClose}>
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Box sx={{ textAlign: 'center', flex: 1 }}>
          {activeView === VIEW_SEARCH && (
            <div style={{ textAlign: 'left' }}>
              <Button
                startIcon={<KeyboardArrowLeftIcon fontSize="large" />}
                onClick={() => {
                  setActiveView(VIEW_LINKED)
                }}
                color="primary"
                size="large"
              >
                Retour
              </Button>
            </div>
          )}
          <Typography variant="h5" mb={3}>
            {displayTitle()}
          </Typography>
          <Typography variant="subtitle1">{`${
            ticket.reference || ticket.id
          } - ${ticket.code}`}</Typography>
        </Box>
        <IconButton
          size="large"
          sx={{ position: 'absolute', right: 15, top: 15 }}
          onClick={handleClose}
        >
          <CloseIcon fontSize="large" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ paddingBottom: 0 }}>
        {activeView === VIEW_LINKED ? (
          <LinkedFrontTicketsTable
            ticketId={ticket.id}
            frontTickets={frontTickets}
            setFrontTickets={setFrontTickets}
            navigateToSearchView={() => setActiveView(VIEW_SEARCH)}
          />
        ) : (
          <FrontTicketSearchTable
            ticketId={ticket.id}
            frontTicketsAlreadyLinked={frontTickets}
            navigateToLinkedView={() => {
              setActiveView(VIEW_LINKED)
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  )
}
